import { background } from "@chakra-ui/react";

export default {
    baseStyle: (props) => ({
        headerStack: {
            spacing: 3,
            align: 'flex-start',
            mt: {base: props.isGiftPage ? 8 : 3, lg: 6}
        },
        priceContainer: {
            m: 0
        },
        currentPrice: {
            textStyle: 'labelSmMd'
        },
        listPrice: {
            textStyle: 'labelXs'
        },
        setPrice: {
            gap: {base: 1, lg: 2}
        },
        promotionBadge: {
            textStyle: 'badge'
        },
        productCallout: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        productCalloutText: {
            textStyle: 'badge',
            color: 'webTypo.textSecondary'
        },
        productName: {
            textStyle: 'labelSmMd',
            color: 'webTypo.textPrimary'
        },
        reviewsFlex: {
            alignItems: 'center',
            gap: '6px',
            cursor: 'pointer'
        },
        reviewsCountText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textPrimary',
            borderBottom: '1px solid',
            borderColor: 'webTypo.textPrimary'
        },
        imageGalleryBox: {
            flex: {base: 1, lg: '2 0'},
            mr: [0, 0, 0, '90px', '90px']
        },
        detailsStack: {
            align: 'stretch',
            spacing: {base: 8, lg: 6},
            flex: 1,
            minWidth: {base: 0, lg: '433px'},
            height: '100%',
            mr: [0, 0, 0, '66px', '66px']
        },
        sizeHeaderFlex: {
            mt: {base: 6}
        },
        sizeLabel: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textPrimary',
            display: 'flex',
            alignItems: 'center'
        },
        swatchImageBox: {
            height: '100%',
            width: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center center'
        },
        swatchTextBox: {
            textStyle: 'bodyXsSRegular',
            // The textStyle carries its own colour; inherit so the swatch button's
            // state colour (selected / disabled) wins instead.
            color: 'inherit'
        },
        notifyMeEnvelope: {
            width: '16px',
            height: '16px',
            position: 'absolute',
            top: '-5px',
            right: '2px'
        },
        errorText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textError'
        },
        inventoryErrorText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textError'
        },
        giftCardErrorText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textError',
            marginBottom: 4
        },
        maxQtyErrorText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textError'
        },
        buttonGroup: {
            width: '100%',
            ...(props.isPDP && {mt: {lg: 4}})
        },
        loyaltyBox: {
            ...(props.isPDP && {mt: {lg: 4}})
        },
        shopSimilarButton: {
            variant: 'webPrimary',
            textStyle: 'webButtonTypography',
            flex: '1'
        },
        earlyAccessButton: {
            variant: 'webPrimary',
            textStyle: 'webButtonTypography',
            flex: '1'
        },
        notifyMeButton: {
            width: '100%',
            variant: 'webPrimary',
            textStyle: 'webButtonTypography',
            flex: '1'
        },
        addToCartButton: {
            width: '100%',
            flex: '1',
            textStyle: 'webButtonTypography'
        },
        wishlistIconButton: {
            border: '1px solid',
            borderColor: 'black',
            bg: 'white',
            h: '48px',
            minWidth: '48px'
        },
        wishlistFullButton: {
            width: '100%',
            variant: 'outline',
            marginBottom: 4
        },
        addToCartBox: {
            display: 'block'
        },
        qtylabel: {
            textStyle: 'labelMd'
        }
    })
}
